// Generated by ReScript, PLEASE EDIT WITH CARE


var default_address = {
  landmark: "",
  location: {
    lat: 0.0,
    lng: 0.0
  }
};

export {
  default_address ,
}
/* No side effect */
